<script lang="ts">
  import { Video } from '@athena-lib/Video';
  import { Image } from '@athena-lib/Image';
  import { getMediaType } from '@athena-lib/asset-utils';
  import type { Asset } from '@storyblok-types';
  import clsx from 'clsx';

  const {
    asset,
    imageClass,
    videoClass,
    class: className,
    innerImageClass,
    loading = 'lazy',
    autoplay,
    loopVideo = true,
    muted = true,
  }: {
    asset: Asset;
    imageClass?: string;
    innerImageClass?: string;
    videoClass?: string;
    class?: string;
    loading?: 'lazy' | 'eager';
    autoplay?: boolean;
    loopVideo?: boolean;
    muted?: boolean;
  } = $props();
  const mediaTypeIs = $derived(getMediaType(asset.filename));
</script>

{#if asset && mediaTypeIs.video}
  <Video
    class={clsx(videoClass, className)}
    src={asset.filename}
    alt={asset.alt}
    autoplay={autoplay ?? false}
    {muted}
    loop={loopVideo}
  />
{:else if asset && mediaTypeIs.image}
  <Image
    class={clsx(imageClass, className)}
    imgClass={clsx(innerImageClass)}
    {loading}
    src={asset.filename}
    alt={asset.alt ?? asset.filename}
  />
{/if}
